import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { DiscoverVideoSection } from '@/components/DiscoverVideoSection';

export default function DiscoverPage() {
  useEffect(() => {
    document.title = 'Discover BITZ CLUB — A World of Privileges';
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0B]" data-testid="discover-page">
      <header className="border-b border-white/10 py-4 px-4">
        <div className="max-w-6xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-white hover:text-[#D4AF37] transition-colors" data-testid="discover-back-home">
            <ArrowLeft className="w-5 h-5" /> BITZ Club Home
          </Link>
        </div>
      </header>
      <DiscoverVideoSection id="presentation" />
    </div>
  );
}
